module.exports = __webpack_public_path__ + "static/media/locked.229529f6.svg";